import React from 'react';

import { AccountContext } from '../../Context/AccountContext';
import { LocalCartContext } from '../../Context/LocalCartContext';
import { ShopwareCartContext } from '../../Context/ShopwareCartContext';
import LocalCart from '../Components/LocalCart/LocalCart';
import ShopwareCart from '../Components/ShopwareCart/ShopwareCart';

const CartContainer: React.FunctionComponent = () => {
    const { isLoggedIn } = React.useContext(AccountContext);

    const context = isLoggedIn ? ShopwareCartContext : LocalCartContext;

    const { cart, setCartVisibility, latestAction, syncFailure } = React.useContext(context);

    const hideCart = () => {
        setCartVisibility(false);
    };

    if (cart.mode === 'shopware') {
        return (
            <>
                <ShopwareCart latestAction={latestAction} hideCart={hideCart} cart={cart} syncFailure={syncFailure} />
            </>
        );
    } else {
        return (
            <>
                <LocalCart latestAction={latestAction} hideCart={hideCart} cart={cart} />
            </>
        );
    }
};

export default CartContainer;
